<!-- 预定说明组件 -->
<template>
	<div class='reserveBox'>
		<div class="column">
			<div class="columnText2">
				是否可拆分购买
			</div>
			<div style="flex: 1;text-align: center;">
				<div class="columnText3">{{ datas.isSplit ? resolutionList[datas.isSplit] : '未填写' }}</div>
			</div>
		</div>
		<div class="column">
			<div class="columnText2">
				免费控房日期
			</div>
			<div style="flex: 1;text-align: center;">
				<div class="columnText3">{{ datas.optionTime ? dateFormatHm(datas.optionTime) : '未填写' }}</div>
			</div>
		</div>
		<div class="column">
			<div class="columnText4">
				上架有效期
			</div>
			<div style="flex: 1;text-align: center;">
				<div class="columnText3">{{ datas.saleOptionTime ? dateFormatHm(datas.saleOptionTime) : '未填写' }}</div>
			</div>
		</div>
		<div class="column">
			<div class="columnText4">
				有效期的解释
			</div>
			<div style="flex: 1;text-align: center;">
				<div class="columnText3">{{ datas.optionTimeExplain ? datas.optionTimeExplain : '未填写' }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { dateFormatHm } from '@/assets/utils/unit'
export default {
	props: {
		datas: {
			type: Object,
			default: {}
		},
		state: {
			type: Number,
			default: 0
		},
	},
	components: {},
	data() {
		return {
			dateFormatHm,
			resolutionList: ['可以拆分购买', '不可拆分购买'],
		}
	},
	computed: {},
	watch: {},
	methods: {

	},
	created() {

	},
	mounted() {

	},
}
</script>
<style lang='scss' scoped>
.reserveBox {
	border-radius: 0.05rem;
	background-color: rgba(250, 250, 250, 1);
	padding: 0 0.1rem;
	.column {
		height: 0.4rem;
		border-top: 1px dotted #E9E9E9;
		display: flex;
		align-items: center;
		justify-content: space-between;

		&:nth-child(1) {
			border-top: none;
			height: 0.4rem;
		}

		.columnText2 {
			color: rgba(149, 144, 144, 1);
			font-size: 0.15rem;
		}

		.columnText3 {
			color: #000000;
			font-size: 0.15rem;
		}

		.columnText4 {
			color: rgba(230, 74, 25, 1);
			font-size: 0.15rem;
		}

		.columnText1 {
			color: #000000;
			font-size: 0.15rem;
			text-align: center;
		}
	}
}
</style>